@let stateTooltip = (stateTooltip$ | async);
@if(stateTooltip){
  <div class="support-container-top">
    <p class="text" [translate]="'HEADER.TECHNICAL_SUPPORT'"></p>
    <p class="number bold">
      <a href="tel:+{{ supportPhone }}">{{ supportPhone }}</a>
    </p>
  </div>
  <div
    class="support-container-down u-flex u-flex-align-items-center"
    (click)="close()"
  >
    <p class="cancel bold" [translate]="'HEADER.CANCEL'"></p>
  </div>
}
